
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/grokking-concurrency",
      function () {
        return require("private-next-pages/books/grokking-concurrency.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/grokking-concurrency"])
      });
    }
  